export const preloadData = () => {
    const images = [];
    const fonts = [
        new FontFace(
            "AvenirLTStd-Black",
            `url(${require("@/assets/fonts/AvenirLTStd-Black.woff2")}) format('woff2'), url(${require("@/assets/fonts/AvenirLTStd-Black.woff")}) format('woff')`
        ),
        new FontFace(
            "AvenirLTStd-Roman",
            `url(${require("@/assets/fonts/AvenirLTStd-Roman.woff2")}) format('woff2'), url(${require("@/assets/fonts/AvenirLTStd-Roman.woff")}) format('woff')`
        ),
        new FontFace(
            "AvenirLTStd-Heavy",
            `url(${require("@/assets/fonts/AvenirLTStd-Heavy.woff2")}) format('woff2'), url(${require("@/assets/fonts/AvenirLTStd-Heavy.woff")}) format('woff')`
        )
    ];
    return {
        images,
        fonts
    };
};
